import { IonLabel, IonCard, IonIcon, IonContent, IonPage, IonCardHeader, IonCardSubtitle, IonSpinner, IonLoading, IonProgressBar, IonAlert, useIonViewWillEnter, useIonViewDidLeave, useIonAlert, IonButton, IonCol, IonGrid, IonRow } from '@ionic/react';
import { list, newspaper, eye, refresh, paperPlane, cloud, walletOutline, speedometerOutline, gitNetworkOutline, enter } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import Config from '../../config/settings';
import UserService from '../../services/user';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import { IonicSwiper } from '@ionic/react';
import './Mining.css';
import 'swiper/swiper-bundle.min.css';
import '@ionic/react/css/ionic-swiper.css';
import { ItemSlideTxt } from '../../models/itemSlideTxt';
import { ItemSlideImg } from '../../models/itemSlideImg';
import { Subscription } from 'rxjs';
import { Shared } from '../../shared/shared';
import { WalletService } from '../Wallet/Wallet.svc';
import UpdateService from '../../services/update';
import { AppVersion } from '@awesome-cordova-plugins/app-version';

const Mining: React.FC<{  shared?: Shared, userService?: UserService, updateService?: UpdateService, isAndroidDevice: boolean }> = ({ shared, userService, updateService, isAndroidDevice }) => {

  SwiperCore.use([IonicSwiper, Autoplay]);

  const maxRemaining = 18327;
  const maxProgressbar = 1;
  const maxTempsIncrement = 33;
  const [incrementedBalance, setIncrementedBalance] = useState<string>();
  const [timeRemaining, setTimeRemaining] = useState<number>(0);
  const [compteur, setCompteur] = useState<number>();
  const [progressBarValue, setProgressBarValue] = useState<number>();
  const [isLoadingMining = false, setIsLoadingMining] = useState<boolean>();
  const [isCollecting = false, setIsCollecting] = useState<boolean>();
  const [donator, setDonator] = useState<string>('0');
  const [showAlertConnection, setShowAlertConnexion] = useState(false);
  const [showOutdatedVersion, setShowOutdatedVersion] = useState(false);
  const [presentAlert] = useIonAlert();
  const [abortAlert] = useIonAlert();
  const [balanceAlert] = useIonAlert();
  const [serviceAlert] = useIonAlert();
  const [confirmAlert] = useIonAlert();
  const [showUpdateDownload, setShowUpdateDownload] = useState<boolean>(false);
  const [showDownload, setShowDownload] = useState<boolean>(false);

  let userServiceSubscribe: Subscription;

  const walletService: WalletService = new WalletService();

  const itemsimg: ItemSlideImg[] = [
    { src: '/assets/img/slide0.png' },
    { src: '/assets/img/slide1.png' },
    { src: '/assets/img/slide2.png' },
    { src: '/assets/img/slide3.png' },
    { src: '/assets/img/slide4.png' },
  ];

  const itemstxt: ItemSlideTxt[] = [
    { text: 'Get ready for the token launch on decentralized markets' },
    { text: 'Buy tokens directly from your mainnet wallet' },
    { text: 'Use your mainnet wallet to send or receive tokens' },
    { text: 'Reactivate your mining session every 7 days' },
    { text: 'The white paper is available in the account page' },
    { text: 'Join our Telegram channel to get announces and news' },
    { text: 'Please share our website to help the project' },
  ];

  useEffect(() => {

    // Boucle toutes les secondes
    if (Number(incrementedBalance) && Number(timeRemaining)) {
      
      setTimeout(() => {
        
        // Incrémentation balance
        if (compteur === 0) {

          if (donator !== '0') {
            setIncrementedBalance((Number(incrementedBalance) + 0.00332).toFixed(5));
          } else {
            setIncrementedBalance((Number(incrementedBalance) + 0.00083).toFixed(5));
          }

          setCompteur(maxTempsIncrement);

          // Incrémentation progressbar
          if (getDays() > -1){
            const remaining = timeRemaining - 1;
            setTimeRemaining(remaining);
            setProgressBarValue(getTimeRemaining(remaining));
          }
        }

        setCompteur(compteur - 1);
      }, 1000);
    }

    // eslint-disable-next-line
  }, [compteur]);
  
  useIonViewWillEnter(() => {

    // Attente du chargement du user service
    userServiceSubscribe = userService.storageInitSubject.subscribe(async (result) => {
      if (result === true) {

        // setCurrency(userService.currency);
        setDonator(userService.donator);

        if (userService.miningCalled === true) {
        } else {
          getBalance(false);
          getLastMining(false);
        }
        
        // Check and update
        if (await AppVersion?.getVersionNumber().then(() => true).catch(() => false)) {
          setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
        }
        //test
        setShowUpdateDownload(await updateService.checkUpdate(userService).then(res => res));
      }
    });
  });

  useIonViewDidLeave(() => {
    if (userServiceSubscribe) {
      userServiceSubscribe.unsubscribe();
    }
  });

  function closeOutdatedVersion() {
    setShowOutdatedVersion(false);
    userService.forceCloseApp();
  }

  /**
   * Récupération des données du compte
   * @param email
   * @param security 
   * @param alerte 
   */
  async function getBalance(alerte: boolean) {
    // setWebBalance(true);

    if (userService) {
      setIsLoadingMining(true);

      const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
      const url = baseUrl + 'select?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

      fetch(url, { signal: AbortSignal.timeout(5000) }).then(
        async (res) => {
          const result = await res.json();
          const balance = (result && result.balance) ? result.balance : 0.00000;
          const access = (result && result.access) ? result.access : 0;
          const donator = (result && result.donator) ? result.donator : 0;
          const country = (result && result.country) ? result.country : null;
          const emailConfirmed = (result && result.email) ? result.email : 0;

          userService.setBalance(balance);
          userService.setAccess(access);
          userService.setDonator(donator);
          userService.setCountry(country);
          userService.setEmailConfirmed(emailConfirmed);

          userService.setTester(access);

          setIncrementedBalance(balance);
        }
      ).catch((_e) => {
        setShowAlertConnexion(true);
      }).finally(() =>
        setIsLoadingMining(false)
      );
    }
  }

  /**
   * Solde du compte
   * @param email
   * @param security 
   * @param alerte 
   */
  async function getLastMining(alerte: boolean) {

    if (userService) {
      setIsLoadingMining(true);

      const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
      const url = baseUrl + 'userdata?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;

      fetch(url, { signal: AbortSignal.timeout(5000) }).then(
        async (res) => {
          const result = await res.json();

          if (result && result.msg && result.msg === 'deprecated') {
            setShowOutdatedVersion(true);
          } else {
            const resultNumber = Number(result.toString());
  
            setTimeRemaining(resultNumber);
            setProgressBarValue(getTimeRemaining(resultNumber));
          }
        }
      ).catch((_e) => {
        setShowAlertConnexion(true);
      }).finally(() =>{
        setIsLoadingMining(false);
        setCompteur(maxTempsIncrement);
      });
    }
  }

  /**
   * Convertion du temps récupéré et valeur de progressbar
   * @param lastMining 
   * @returns 
   */
  function getTimeRemaining(lastMining: number) {
    return maxProgressbar / maxRemaining * lastMining;
  }

  /**
   * Cacher les valeurs
   */
  function hideValue() {
    const compteurValeur = document.getElementById('compteur-valeur');
    if (compteurValeur.classList.contains('compteur-hidden')) {
      compteurValeur.classList.remove('compteur-hidden')
    } else {
      compteurValeur.classList.add('compteur-hidden');
    }
  }

  /**
   * Réactivation du mining
   */
  function reactivateMining() {    
    if (timeRemaining === 0) {
      enableMining();
      getLastMining(false);
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'Cloud mining reenabled.',
        buttons: ['OK'],
      });
    } else {
      presentAlert({
        header: 'Message',
        subHeader: '',
        message: 'Cloud mining cannot be reactivated before the end of the period.',
        buttons: ['OK'],
      });
    }
  }

  function getDays() {
    const nbOfDays: number = Number((progressBarValue / (1 / 7)).toFixed(0));
    
    if (timeRemaining === 0) {
      disableMining();
    } else {
      enableMining();
    }

    return nbOfDays;
  }

  function disableMining() {
    const miningButton = document.getElementById('miningButton');
    if (miningButton) {
      miningButton.classList.remove('enabled');
      miningButton.classList.add('disabled');
      miningButton.innerHTML = 'Disabled';
    }

    const miningSpinner = document.getElementById('miningSpinner');
    
    if (miningSpinner) {
      miningSpinner.classList.remove('enabled');
      miningSpinner.classList.add('disabled');
    }
  }

  function enableMining() {
    const miningButton = document.getElementById('miningButton');
    
    if (miningButton) {
      miningButton.classList.remove('disabled');
      miningButton.classList.add('enabled');
      miningButton.innerHTML = 'Enabled';
    }

    const miningSpinner = document.getElementById('miningSpinner');
    
    if (miningSpinner) {
      miningSpinner.classList.remove('disabled');
      miningSpinner.classList.add('enabled');
    }
  }
  
  function generateInvite() {
    let length = 8;
    let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let generatedCode = '';

    for (var i = 0, n = charset.length; i < length; ++i) {
      generatedCode += charset.charAt(Math.floor(Math.random() * n));
    }

    alert('You invite code is : ' + generatedCode);
    alert('Invite code service is currently disabled');
    
    return generatedCode;
  }

  async function collectMining() {
    const currentBalance = await userService.getBalance();

    if (Number(currentBalance) > 1000) {
      presentAlert({
        header: 'Info',
        subHeader: '',
        message: 'You want to collect ' + currentBalance + ' NSA <b>to your wallet</b>, please confirm. It can take some minutes, be patient.',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              console.log('Collect canceled');
            },
          },
          {
            text: 'OK',
            role: 'confirm',
            handler: async () => {
              console.log('Collect confirmed, checking pubkey');

              const pubkey = await userService.getPubkey();
              if (pubkey?.length > 0) {
              console.log('Pubkey exists: ', pubkey);

                const solanaBalance = await getSolanaBalance();
                console.log('Balance: ', solanaBalance, Number(solanaBalance));

                if (Number(solanaBalance) >= 0.0005) {

                  const nsaBalance = await getNsaTokenAccountsByOwner();
                  console.log('NSA Balance: ', Number(nsaBalance));

                  if (nsaBalance != null && Number(nsaBalance) >= 0) {
                    const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
                    const url = baseUrl + 'collect_open?email=' + userService.email + '&v=' + Config.version;
                    
                    fetch(url, { signal: AbortSignal.timeout(5000) }).then(
                      async (res) => {
                        const result = await res.json();
                        console.log('Collect check result', result);
    
                        if (result && result === true) {
                          
                          const baseUrl = (Config.debugMode === false) ? Config.url : Config.urlDebug;
                          const collectURL = baseUrl + 'collect?email=' + userService.email + '&security=' + userService.security + '&v=' + Config.version;
    
                          setIsCollecting(true);
    
                          fetch(collectURL).then(
                            async (res) => {
                              const result = await res.json();
                              if (result.error) {
                                serviceAlert({
                                  header: 'Error',
                                  subHeader: '',
                                  message: result.error,
                                  buttons: ['OK']
                                });
                              }  else {
                                confirmAlert({
                                  header: 'Info',
                                  subHeader: '',
                                  message: result.msg + ' Do you want to open the transaction page ?',
                                  buttons: [
                                    {
                                      text: 'Open',
                                      role: 'open',
                                      handler: () => {
                                        window.open(result.url)
                                      },
                                    },
                                    {
                                      text: 'Quit',
                                      role: 'quit',
                                      handler: () => {
                                        console.log('Collect terminated');
                                      },
                                    } 
                                  ]
                                });
    
                                // Refresh du compteur mining
                                setTimeout(() => {
                                  refreshMiningData();
                                }, 1000);
                              }
                            }
                          ).finally(() => setIsCollecting(false));
                        } else if (result && result['msg'] === false) {
                          console.log('Collect unconfirmed');
                          serviceAlert({
                            header: 'Info',
                            subHeader: '',
                            message: 'Service is currently disabled.',
                            buttons: ['OK']
                          });
                        }
                      }
                    ).catch(() => {
                      setShowAlertConnexion(true);
                    });
                  } else {
                    balanceAlert({
                      header: 'Info',
                      subHeader: '',
                      message: 'You have to create the NSA asset in your wallet. Go to the wallet and click on Create NSA asset.',
                      buttons: ['OK']
                    });
                  }

                } else {
                  balanceAlert({
                    header: 'Info',
                    subHeader: '',
                    message: 'You need a minimum of 0.0005 SOL in your wallet.',
                    buttons: ['OK']
                  });
                }
              } else {
                console.log('Pubkey not exists: ', pubkey);

                abortAlert({
                  header: 'Info',
                  subHeader: '',
                  message: 'You have not created a wallet, create one in the wallet page and create the assets.',
                  buttons: ['OK']
                });
              }
            },
          },
        ]
      });
    } else {
      presentAlert({
        header: 'Info',
        subHeader: '',
        message: 'You need to collect a minimum of 1000 NSA <b>to your wallet</b>',
        buttons: ['OK']
      });
    }
  }

  /**
   * Récupération de la balance du wallet Solana
   */
  async function getSolanaBalance() {

    if (userService && userService.pubkey) {

      return walletService
        .getSolanaBalance(
          userService
        ).then(
          async (res) => {
  
            const resultat = await res.json();
            
            let balance = (resultat?.result?.value) ? resultat?.result?.value : 0;
            
            // Parser la balance en valeur réelle
            const balanceString: string = (balance / 1000000000).toString();
            return balanceString;
          }
        ).catch((_e) => {
            console.log('error ' + _e);
        });
    }
  }

    /**
   * Récupération des comptes du wallet Solana
   */
    async function getNsaTokenAccountsByOwner() {

      if (userService && userService.pubkey) {
  
        return walletService
          .getSolanaTokenAccountsByOwner(
            Config.tokenNsaAddress,
            userService
          ).then(
            async (res) => {
              const resultat = await res.json();
    
              const results = resultat?.result?.value;
              console.log('results', results);
              
              let convertResult = null;
            
              if (results) {  
                results.forEach((item: any) => {
                  const info = item.account.data.parsed.info;
                  console.log('mint', Config.tokenNsaAddress, info.mint);
                  if (info.mint === Config.tokenNsaAddress) {
                    convertResult = info.tokenAmount.amount === '0' ? 0 : Number(info.tokenAmount.amount) / 1000000000;
                    console.log('mint convert result', convertResult);
                  }
                });
              }
              
              return convertResult;
            }
          ).catch((_e) => {
            console.log('error ' + _e);
          });
      }
    }

  function refreshMiningData() {
    getBalance(false);
    getLastMining(false);
  }

  function openChest(id: number) {
    alert('This chest slot is empty');
  }

  /**
   * Ouvre la page de presale
   */
  function gotoWallet() {
    const page = 'wallet';
    const presaleTab: HTMLElement | null = document.querySelector('#tab-button-' + page);
    presaleTab?.click();
  }

  return (
    <IonPage>

      { showAlertConnection &&
          <div className="no-connection">
            <span>
              <h1>Please check your internet connection.</h1>
              <p>If your connection is working, it is likely that the servers are under maintenance.</p>
              <p>Please visit the support channels for information.</p>
              <h2>Your wallet remains usable during maintenance.</h2>
              <IonButton color="secondary" style={{ height: "52px" }} onClick={() => gotoWallet()}><IonIcon icon={enter} style={{ paddingRight: "5px" }}></IonIcon> Wallet</IonButton>
            </span>
          </div>
      }

      <IonContent fullscreen>

        { showUpdateDownload &&
          <div style={{zIndex: 9999, position: 'fixed', marginTop: '150px', marginLeft: 'calc(50% - 232.3px / 2)', background: 'black', display: 'flex', flexDirection: 'column', borderRadius: '15px', padding: '15px'}}>
            <h1 style={{marginTop: 0}}>Info</h1>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>An update is available.</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>Your current version is: {updateService.versionInstalled}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}>The latest version is: {updateService.versionServer}</p>
            <p style={{marginTop: '.5rem', marginBottom: 0, fontSize: '16px'}}><b>Proceed to the update ?</b></p>
            <div style={{textAlign: 'right', paddingTop: '.7rem'}}>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px'}} onClick={() => setShowUpdateDownload(false)}>No</button>
              <button style={{width: '50px', padding: '7px 10px', borderRadius: '5px', marginLeft: '5px', background: 'rgb(133,231,133)', color: 'black'}} onClick={() => {setShowDownload(true); updateService.updateApplication(userService)}}>Yes</button>
            </div>
          </div>
        }
        <IonLoading message="Downloading update please wait... ~15mb" isOpen={showDownload}></IonLoading>

        {
          isLoadingMining &&
          <IonLoading
            cssClass='my-custom-class'
            isOpen={isLoadingMining}
            message={'Loading'}
            duration={0}
            spinner={'dots'}
          />
        }

        {
          isCollecting &&
          <IonLoading
            cssClass='my-custom-class'
            isOpen={isCollecting}
            message={'Waiting transaction confirmations, please wait'}
            duration={0}
            spinner={'dots'}
          />
        }
        
        <div className="container-mining">

          {/* <IonAlert
            isOpen={showAlertConnection}
            onDidDismiss={() => closeConnexionAlert()}
            cssClass='my-custom-class'
            header={'Alert'}
            subHeader={'Server connexion error'}
            message={'Please check your internet connexion. If your connexion is activated and working, servers can be in maintenance so retry in few hours. Please take information on Telegram channel, thanks.'}
            buttons={['Exit']}
          /> */}

          <IonAlert
            isOpen={showOutdatedVersion}
            onDidDismiss={() => closeOutdatedVersion()}
            cssClass='my-custom-class'
            header={'Alert'}
            subHeader={'Your application version is OUTDATED'}
            message={'Please upgrade the application from PlayStore, thanks.'}
            buttons={['Exit']}
          />

          <div className="container-slides-images">
            <Swiper
              effect="fade"
              spaceBetween={50}
              slidesPerView={1}
              pagination={true}
              loop={true}
              // disableOnInteraction={false}
              autoplay={true}
            // onSlideChange={(event: any) => console.log('slide change', event)}
            // onSwiper={(swiper: any) => console.log(swiper)}
            >

              {itemsimg.map((image, i) => (
                <SwiperSlide key={'img' + i} style={{ backgroundImage: image.src }}>
                  <div>
                    <img src={image.src} alt="slide" />
                  </div>
                </SwiperSlide>
              ))}

            </Swiper>
          </div>

          <div className="container-slides-textes">
            <IonIcon className="icon-icon-inside" icon={newspaper} />

            <Swiper
              spaceBetween={50}
              slidesPerView={1}
              direction={'vertical'}
              loop={true}
              autoplay={true}
            // onSlideChange={(event: any) => console.log('slide change', event)}
            // onSwiper={(swiper: any) => console.log(swiper)}
            >

              {itemstxt.map((txt, i) => (
                <SwiperSlide key={'txt' + i}>
                  <IonLabel color="primary">{txt.text}</IonLabel>
                </SwiperSlide>
              ))}

            </Swiper>

            <IonIcon className="icon-icon-list" icon={list} />
          </div>

          <div className="container-mining-common">

            <p className="compteur-text">Earned: <span id="compteur-valeur" className="compteur-valeur">{incrementedBalance}</span> NSA <IonIcon onClick={() => { hideValue() }} className="icon-icon-list" icon={eye} />  <IonIcon onClick={() => { refreshMiningData() }} className="icon-icon-list" icon={refresh} /></p>

            <div className="common-buttons">
              <IonCard onClick={() => { reactivateMining() }}>
                <IonIcon color="primary" className="icon-icon-list" icon={cloud} />
                <IonSpinner id='miningSpinner'  name="crescent" className="enabled" />
                <IonCardHeader>
                  <IonCardSubtitle id='miningButton' className='enabled'>Enabled</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard id="present-alert" onClick={() => presentAlert({
                  header: 'Info',
                  subHeader: '',
                  message: (userService.donator && userService.donator === '1')
                    ? 'You are a Donator and your mining is currently at <b>x4 speed</b>.'
                    : 'To speedup your mining you need to be a donator, goto Account page and follow donator process.',
                  buttons: ['OK'],
                })}>
                <IonIcon color="primary" className="icon-icon-list" icon={speedometerOutline} />
                { userService.donator && userService.donator === '1' && <IonSpinner id='speedupSpinner'  name="crescent" />}
                <IonCardHeader>
                  <IonCardSubtitle>Speedup</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard onClick={() => {  generateInvite() }}>
                <IonIcon color="primary" className="icon-icon-list" icon={gitNetworkOutline} />
                <IonCardHeader>
                  <IonCardSubtitle>Invite</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              <IonCard onClick={() => {  collectMining() }}>
                <IonIcon color="primary" className="icon-icon-list" icon={walletOutline} />
                <IonCardHeader>
                  <IonCardSubtitle>Collect</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>

              {/* <IonCard onClick={() => { window.open('https://nebula.spl-token.com') }}>
                <IonIcon color="primary" className="icon-icon-list" icon={paperPlane} />
                <IonCardHeader>
                  <IonCardSubtitle>Website</IonCardSubtitle>
                </IonCardHeader>
              </IonCard> */}
              
              {/* <IonCard onClick={() => { window.open('https://t.me/nebula_android_application') }}>
                <IonIcon color="primary" className="icon-icon-list" icon={telescope} />
                <IonCardHeader>
                  <IonCardSubtitle>Telegram</IonCardSubtitle>
                </IonCardHeader>
              </IonCard> */}
              
              <IonCard onClick={() => { window.open('https://t.me/nebula_android_application') }}>
                <IonIcon color="primary" className="icon-icon-list" icon={paperPlane} />
                <IonCardHeader>
                  <IonCardSubtitle>Telegram</IonCardSubtitle>
                </IonCardHeader>
              </IonCard>
            </div>

            <div className="common-remaining">
                <p>Time remaining {(getDays() > 1 || getDays() === 0) ? getDays() + ' days' : (getDays() === 1 ) ? getDays() + ' day' : '0 days'} ({timeRemaining * 33} sec.)</p>
                <IonProgressBar className="progressbar-theme" value={progressBarValue} buffer={0}></IonProgressBar>
                <p className="tiny-text padding-top">You have to reactivate cloud mining each 7 days by reopening the app.</p>
            </div>

            <div className="container-myst-chest">
              <IonGrid>
                <IonRow>
                  <IonCol size="3">
                    <div className="chest-col">
                      <IonLabel>0d 0h 0mn</IonLabel>
                      <span>No Myst.<br/>Chest</span>
                      <IonButton onClick={() => openChest(1)}>Open</IonButton>
                    </div>
                  </IonCol>
                  <IonCol size="3">
                    <div className="chest-col">
                      <IonLabel>0d 0h 0mn</IonLabel>
                      <span>No Myst.<br/>Chest</span>
                      <IonButton onClick={() => openChest(2)}>Open</IonButton>
                    </div>
                  </IonCol>
                  <IonCol size="3">
                    <div className="chest-col">
                      <IonLabel>0d 0h 0mn</IonLabel>
                      <span>No Myst.<br/>Chest</span>
                      <IonButton onClick={() => openChest(3)}>Open</IonButton>
                    </div>
                  </IonCol>
                  <IonCol size="3">
                    <div className="chest-col">
                      <IonLabel>0d 0h 0mn</IonLabel>
                      <span>No Myst.<br/>Chest</span>
                      <IonButton onClick={() => openChest(4)}>Open</IonButton>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
              
            </div>

            {/* <div className="container-mining-charts">
              <IonList className="chart-token-select">
                <IonItem color="secondary">
                  <IonSelect placeholder="Select token" defaultValue={'msol'} onIonChange={(token) => changeChartToken(token)}>
                    <IonSelectOption value="nsa">Nsa</IonSelectOption>
                    <IonSelectOption defaultChecked={true} value="msol">mSol</IonSelectOption>
                    <IonSelectOption value="sol">Sol</IonSelectOption>
                  </IonSelect>
                </IonItem>
              </IonList>
              <div id="chartdiv" className="chartdiv">
                <p id="no-api-key">Loading Market data...</p>
              </div>
              <div className="mining-charts-hide-logo"></div>
            </div> */}

            <div className="common-currencies">
            
            </div>
          </div>

        </div>
      </IonContent>
    </IonPage >
  );
};

export default Mining;
